import { createAsyncThunk } from '@reduxjs/toolkit';
import paymentService from '../../../api/services/payment';

export const createPaymentsClient = createAsyncThunk('payment/createPaymentsClient', async ({ id, body }) => {
  return await paymentService.createPaymentsForClient(id, body);
});

export const acceptClientPayment = createAsyncThunk('payment/acceptClientPayment', async body => {
  return await paymentService.acceptPaymentForClient(body);
});

export const getClientPayment = createAsyncThunk('payment/getClientPayment', async ({ id }) => {
  return await paymentService.getClientPayment(id);
});

export const rejectPaymentForClient = createAsyncThunk('payment/rejectPaymentForClient', async body => {
  return await paymentService.rejectPaymentForClient(body);
});

export const createClientPayment = createAsyncThunk('payment/createClientPayment', async ({ id, body }) => {
  return await paymentService.createClientPayment(id, body);
});

export const getClientPaymentPlan = createAsyncThunk('payment/getClientPaymentPlan', async ({ id }) => {
  return await paymentService.getClientPaymentPlan(id);
});

export const editPaymentPlanForClient = createAsyncThunk('payment/editPaymentPlanForClient', async ({ id, body }) => {
  return await paymentService.editPaymentPlanForClient(id, body);
});

export const deleteClientPayment = createAsyncThunk('payment/deleteClientPayment', async ({ id }) => {
  return await paymentService.deleteClientPayment(id);
});
